import { ChangeDetectionStrategy, Component, HostBinding, ViewChild, inject, output, signal } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { PopperContentComponent } from '@frontend/vanilla/features/popper';
import { NgxFloatUiModule } from 'ngx-float-ui';

import { MarketHeaderTooltipService } from '../../market-header-tooltip/market-header-tooltip.service';
import { BAB_TOOLTIP_HOST_INJECTION_TOKEN } from '../../priceboost/components/price-boost.component';

type ViewModel = { badgeText: string; tooltipTitle: string; tooltipContent: string };

const varScopeClass = 'market-header-bet-builder-signposting-var-scope';

@Component({
    selector: 'ms-market-header-bet-builder-badge',
    templateUrl: './market-header-bet-builder-badge.component.html',
    styleUrls: ['./market-header-bet-builder-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgxFloatUiModule, PopperContentComponent],
})
export class MarketHeaderBetBuilderBadgeComponent {
    private marketHeaderTooltipService = inject(MarketHeaderTooltipService);
    private babTooltipHost = inject(BAB_TOOLTIP_HOST_INJECTION_TOKEN, { optional: true });

    private epcotConfig = inject(EpcotConfig);

    protected readonly tooltipInfo: ViewModel;
    protected readonly isTooltipVisible = signal<boolean>(false);
    tooltipAppendTo: string;
    @ViewChild('popper') protected popperEl: PopperContentComponent;
    @HostBinding('class') hostClass = varScopeClass;
    readonly isBadgeEnabled = output<void>();

    @HostBinding('class.epcot-enabled')
    get isEpcotEnabled(): boolean {
        return this.epcotConfig.isEnabled;
    }

    constructor() {
        const sitecore = inject(Sitecore);

        this.tooltipInfo = {
            badgeText: sitecore.betBuilderSignposting.BadgeText,
            tooltipTitle: sitecore.betBuilderSignposting.TooltipTitle,
            tooltipContent: sitecore.betBuilderSignposting.TooltipContent,
        };

        this.tooltipAppendTo = this.babTooltipHost ?? 'ng-component';
    }

    toggleTooltip(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();

        if (!this.isTooltipVisible()) {
            this.marketHeaderTooltipService.tooltip = this.popperEl;
        }
        this.isTooltipVisible.set(!this.isTooltipVisible());
        this.isBadgeEnabled.emit();
    }

    closeTooltip(): void {
        this.isTooltipVisible.set(false);
        this.isBadgeEnabled.emit();
    }
}
